// extracted by mini-css-extract-plugin
export default {"user-data":"userDataProfileContainer_user-data__kINo-"};